import { useTranslation } from 'react-i18next';
import { Bar } from 'recharts';
import { DateRange } from '../../../../components/dates/RangeCalendar';
import { WorkoutWithCycleAndSession } from '../../types';
import { ActualWorkout, PhaseSpan } from '../types';
import {
  ACTUAL_COLOR,
  BowlingDayChart,
  PLANNED_COLOR,
} from './BowlingDayChart';

export const BowlingStackedChart = (props: {
  actualWorkouts: ActualWorkout[];
  prescriptionWorkouts: WorkoutWithCycleAndSession[];
  phases: PhaseSpan[];
  dateRange: DateRange;
}) => {
  const { t } = useTranslation();
  return (
    <BowlingDayChart
      title={t('stackedPlannedVsActuals')}
      {...props}
      // Stack actual on the bottom, planned on top, into a single bar per day.
      renderBars={({ hasActual }) => (
        <>
          {hasActual && (
            <Bar
              dataKey="actual"
              name={t('actuals')}
              stackId="day"
              fill={ACTUAL_COLOR}
              isAnimationActive={false}
            />
          )}
          <Bar
            dataKey="planned"
            name={t('planned')}
            stackId="day"
            fill={PLANNED_COLOR}
            radius={[2, 2, 0, 0]}
            isAnimationActive={false}
          />
        </>
      )}
    />
  );
};
